
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sfstandard",
      function () {
        return require("private-next-pages/sfstandard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sfstandard"])
      });
    }
  